module.exports = __webpack_public_path__ + "img/kma_gallery8.6cbd8624.jpg";